'use strict';

import type { IndProvider } from '../../Entities/Ind/IndProvider';
import { EntityCollection } from '../EntityCollection';

export class IndProviderCollection extends EntityCollection<IndProvider> {}
